export default {
  darkGrey: "#494949",
  blue: "#007bff"
};
